export default __webpack_public_path__ + "static/media/onlyfans.86b904af.svg";